import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo, useContext } from 'react';
import MuiTableCell from '@material-ui/core/TableCell';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { TableCellStyle } from './styles';
import { RcTableCellClasses } from './utils';
import { RcButtonBase } from '../../Buttons';
import { RcIcon } from '../../Icon';
import { JumpToLatest as DescSortIcon, JumpToUnread as AscSortIcon, } from '@ringcentral/juno-icon';
import clsx from 'clsx';
import { RcTableContext } from '../context';
var _RcTableCell = forwardRef(function (props, ref) {
    var _a = useThemeProps({ props: props, name: 'RcTableCell' }), classesProp = _a.classes, childrenProp = _a.children, size = _a.size, sortDirection = _a.sortDirection, _b = _a.activeSort, activeSort = _b === void 0 ? false : _b, rest = __rest(_a, ["classes", "children", "size", "sortDirection", "activeSort"]);
    var classes = combineClasses(RcTableCellClasses, classesProp);
    // prevent mui classes warning
    var sortButton = classes.sortButton, activeSortClass = classes.activeSort, sortIcon = classes.sortIcon, tableCellClasses = __rest(classes, ["sortButton", "activeSort", "sortIcon"]);
    var children = useMemo(function () {
        var _a;
        if (sortDirection) {
            return (React.createElement(RcButtonBase, { disableRipple: true, className: clsx(classes.sortButton, (_a = {},
                    _a[classes.activeSort] = activeSort,
                    _a)) },
                childrenProp,
                React.createElement(RcIcon, { size: "small", className: classes.sortIcon, symbol: sortDirection === 'asc' ? AscSortIcon : DescSortIcon })));
        }
        return childrenProp;
    }, [activeSort, childrenProp, classes, sortDirection]);
    return (React.createElement(MuiTableCell, __assign({}, rest, (sortDirection ? { sortDirection: sortDirection } : {}), { ref: ref, classes: tableCellClasses }), children));
});
var RcTableCell = styled(_RcTableCell).attrs(function (_a) {
    var _b;
    var sizeProp = _a.size, _c = _a.sortDirection, sortDirection = _c === void 0 ? false : _c, rest = __rest(_a, ["size", "sortDirection"]);
    var contextSize = useContext(RcTableContext).size;
    var size = (_b = sizeProp !== null && sizeProp !== void 0 ? sizeProp : contextSize) !== null && _b !== void 0 ? _b : 'medium';
    return __assign(__assign({}, rest), { size: size, sortDirection: sortDirection });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), TableCellStyle);
RcTableCell.displayName = 'RcTableCell';
export { RcTableCell };
var templateObject_1;
